// custom-reviews.js
document.addEventListener('DOMContentLoaded', () => {
  const TEXT = 'Recenzie verificată';

  function replaceDates(root = document) {
    root
      .querySelectorAll(
        '.jdgm-rev__timestamp, .jdgm-rev__date, time.jdgm-rev__timestamp'
      )
      .forEach(el => {
        el.textContent = TEXT;
      });
  }

  // 1) Primul pas: încearcă imediat după load
  replaceDates();

  // 2) Observă doar widgetul Judge.me, care se actualizează dinamic
  const target =
    document.querySelector('.jdgm-rev-widg') ||
    document.querySelector('#judgeme_product_reviews');

  if (target) {
    const obs = new MutationObserver(mutations => {
      for (const m of mutations) {
        m.addedNodes.forEach(node => {
          if (node.nodeType === 1) replaceDates(node);
        });
      }
    });
    obs.observe(target, { childList: true, subtree: true });
  } else {
    // fallback: observă body dacă nu găsește widgetul (mai rar necesar)
    const obs = new MutationObserver(() => replaceDates());
    obs.observe(document.body, { childList: true, subtree: true });
  }
});
